<div class="w-full bg-white">
  <div class="max-w-6xl mx-auto px-4 py-4 border-b border-gray-200 lg:px-8">
    <div class="flex items-center justify-between">
      <a [href]="homeRoute" class="flex items-center">
        <!-- Logo Section -->
        <img [src]="logoUrl" [alt]="logoAlt" class="h-12 w-auto object-contain" />
        <span class="sr-only">Home</span>
      </a>
      <!-- Desktop Menu -->
      <div class="hidden lg:flex items-center space-x-8 ml-auto">
        <a
          *ngFor="let link of navigationLinks"
          (click)="navigate(link)"
          [ngClass]="{ 'text-black font-bold': activeLink === link.route }"
          class="text-gray-700 hover:text-black hover:font-bold cursor-pointer"
          >{{ link.name }}</a
        >

        <!-- Shopping Cart Icon with Badge -->
        <hypenation-shared-shopping-cart
          (click)="navigateToCart()"
          [numberOfItems]="numberOfItems"
          class="cursor-pointer"
        ></hypenation-shared-shopping-cart>

        <!-- User Avatar with Dropdown (Desktop) -->
        <div *ngIf="isAuthenticated()" class="relative user-menu-container">
          <button
            type="button"
            (click)="toggleUserMenu()"
            class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400"
            [title]="userEmail || 'User'"
          >
            <span class="text-sm font-semibold text-gray-700">{{ userInitials }}</span>
          </button>
          
          <!-- Dropdown Menu -->
          <div
            *ngIf="isUserMenuOpen"
            class="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200"
            (click)="$event.stopPropagation()"
          >
            <div class="px-4 py-2 border-b border-gray-200">
              <p class="text-sm font-medium text-gray-900">Logged in as</p>
              <p class="text-sm text-gray-600 truncate">{{ userEmail }}</p>
            </div>
            <button
              (click)="logout()"
              class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
      <!-- Mobile Menu Button -->
      <div class="flex items-center gap-4 lg:hidden">
        <hypenation-shared-shopping-cart
          (click)="navigateToCart()"
          [numberOfItems]="numberOfItems"
          class="cursor-pointer"
        ></hypenation-shared-shopping-cart>

        <button
          type="button"
          class="p-2 rounded-md text-gray-600 hover:bg-gray-100 focus:outline-none"
          (click)="toggleMobileMenu()"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16m-7 6h7"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Mobile Menu -->
  <div *ngIf="isMobileMenuOpen" class="lg:hidden border-t border-gray-200">
    <div class="px-4 py-3 space-y-2">
      <a
        *ngFor="let link of navigationLinks"
        (click)="navigate(link)"
        [ngClass]="{ 'text-black font-bold': activeLink === link.route }"
        class="block text-gray-700 hover:text-black hover:font-bold p-4 cursor-pointer"
        >{{ link.name }}</a
      >
      
      <!-- User Info and Logout (Mobile) -->
      <div *ngIf="isAuthenticated()" class="border-t border-gray-200 mt-2 pt-2">
        <div class="px-4 py-2">
          <p class="text-xs text-gray-500 mb-1">Logged in as</p>
          <p class="text-sm font-medium text-gray-900 truncate">{{ userEmail }}</p>
        </div>
        <button
          (click)="logout(); toggleMobileMenu()"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded"
        >
          Logout
        </button>
      </div>
    </div>
  </div>
</div>

